module.exports = __webpack_public_path__ + "static/conversation-50fa1df16e20124949bd667a7968bcdd.png";